import { Button } from "react-migration/components/DeprecatedButton";
import { useDropdownMenuContext } from "../DropdownMenu";

import classNames from "classnames";
import { useCallback } from "react";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export interface ActionBarProps {
  onCancel: () => void;
  onApply: () => void;
}

export const ActionBar = ({ onCancel, onApply }: ActionBarProps) => {
  const { t } = useTranslation();

  const { closeMenu } = useDropdownMenuContext();

  const handleCancel = useCallback(() => {
    onCancel();
    closeMenu();
  }, [closeMenu, onCancel]);
  const handleApply = useCallback(() => {
    onApply();
    closeMenu();
  }, [closeMenu, onApply]);

  return (
    <div
      className={classNames("p-4", "flex", "flex-row", "justify-end", "gap-2")}
      data-testid="select-filter-action-bar"
    >
      <Button.Secondary onClick={handleCancel}>{t("sites.pipeline.filters.cancel")}</Button.Secondary>
      <Button.Primary onClick={handleApply}>{t("sites.pipeline.filters.apply")}</Button.Primary>
    </div>
  );
};
